import { jsPDF } from 'jspdf'
// @ts-expect-error - Font file
import { openSansBoldFont } from '#app/utils/pdf/fonts/OpenSans-bold.js'
// @ts-expect-error - Font file
import { openSansNormalFont } from '#app/utils/pdf/fonts/OpenSans-normal.js'
// @ts-expect-error - Font file
import { poppinsBoldFont } from '#app/utils/pdf/fonts/Poppins-bold.js'
// @ts-expect-error - Font file
import { poppinsNormalFont } from '#app/utils/pdf/fonts/Poppins-normal.js'
import logoHorizontal from '/img/logo-horizontal.png'

export const addFonts = (doc: jsPDF) => {
  doc.addFileToVFS('OpenSans-normal.ttf', openSansNormalFont)
  doc.addFont('OpenSans-normal.ttf', 'OpenSans', 'normal')

  doc.addFileToVFS('OpenSans-bold.ttf', openSansBoldFont)
  doc.addFont('OpenSans-bold.ttf', 'OpenSans', 'bold')

  doc.addFileToVFS('Poppins-bold.ttf', poppinsBoldFont)
  doc.addFont('Poppins-bold.ttf', 'Poppins', 'bold')

  doc.addFileToVFS('Poppins-normal.ttf', poppinsNormalFont)
  doc.addFont('Poppins-normal.ttf', 'Poppins', 'normal')
}

export const COLORS = {
  black: '#1C2024',
  cyan: {
    11: '#0C7792',
  },
  mauve: {
    3: '#F3F1F5',
    8: '#DFDCE3',
    11: '#65636D',
  },
  mint: {
    1: '#EFFEFA',
  },
  bookGradient: {
    top: '#BBEEE2',
    bottom: '#DDFBF3',
  },
}

export const topMargin = 38
export const marginX = 40

export const logoHeight = 16
export const logoBottomMargin = 26

export const fontSizeOneLineHeightFactor = 1.33
export const fontSizeTwoLineHeightFactor = 1.5

export function createDoc() {
  const doc = new jsPDF({
    unit: 'px',
    hotfixes: ['px_scaling'],
  })

  addFonts(doc)
  doc.setTextColor(COLORS.black)

  return doc
}

export function formatFilename(name: string) {
  return name.toLocaleLowerCase().replaceAll(' ', '-')
}

export function calculatePageWidth(doc: jsPDF) {
  return doc.internal.pageSize.width - 2 * marginX
}

export const fontSizeInPt = (fontSize: number) => {
  switch (fontSize) {
    case 1:
      return 9
    case 2:
      return 12
    case 4:
      return 14
    case 5:
      return 18
    case 6:
      return 21
    case 7:
      return 36
    default:
      return 12
  }
}

export const lineHeightWithSpacing = (
  fontSize: number,
  spacingInPixels: number = 0,
) => {
  let fontSizePixels = 24

  switch (fontSize) {
    case 1:
      fontSizePixels = 16
      break
    case 2:
      fontSizePixels = 24
      break
    case 4:
      fontSizePixels = 20
      break
    case 5:
      fontSizePixels = 36
      break
  }

  return fontSizePixels + spacingInPixels
}

export const addPage = (y: number, doc: jsPDF) => {
  if (y >= 1000) {
    doc.addPage()
    return true
  }

  return false
}

export function addLogo(doc: jsPDF, y: number) {
  const logoWidth = 95

  doc.addImage(
    logoHorizontal,
    'PNG',
    marginX,
    y,
    logoWidth,
    logoHeight,
    undefined,
    'NONE',
  )
}

export function addPageHeader(doc: jsPDF) {
  let y = topMargin
  const { pageNumber } = doc.getCurrentPageInfo()
  const pageNumberWidth = doc.getTextWidth(`${pageNumber}`) + 4

  addLogo(doc, y)

  doc
    .setFontSize(fontSizeInPt(1))
    .setFont('OpenSans', 'normal')
    .text(
      `${pageNumber}`,
      doc.internal.pageSize.width - marginX - pageNumberWidth,
      y + 8,
    )

  y += logoHeight + logoBottomMargin

  return y
}

export const formatMarkdown = (text: string) =>
  text.replace(/^(\s*)(\*)/, (_match, whitespace) => `${whitespace}\u2022`)

export const getTextDimensionsInPt = (
  doc: jsPDF,
  text: string,
  options: { fontSize: number; maxWidth: number },
) => doc.getTextDimensions(text, options)
